import { AsyncButton } from "aic";
import { Col, Container, Modal, Row } from "react-bootstrap";

interface ModalProps {
  id: string;
  show: boolean;
  beingRemovedType: string;
  beingRemovedName: string;
  onOk: () => void;
  onCancel: () => void;
}

/**
 * Confirmation modal for removing items with destructive action warning.
 *
 * @param props - The component props
 * @param props.id - Unique identifier for the modal
 * @param props.show - Whether the modal is currently displayed
 * @param props.beingRemovedType - Type of item being removed (e.g., "Template", "User")
 * @param props.beingRemovedName - Name or identifier of the item being removed
 * @param props.onOk - Callback invoked when removal is confirmed
 * @param props.onCancel - Callback invoked when removal is cancelled
 */
export const RemoveModal = ({
  id,
  show,
  beingRemovedType,
  beingRemovedName: beingRemovedName,
  onOk,
  onCancel,
}: ModalProps): React.ReactElement => {
  // Render modal
  return (
    <>
      <Modal
        id={id}
        show={show}
        onHide={onCancel}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <Container>Remove {beingRemovedType}</Container>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <h5>Are you sure you want to remove</h5>
              <Col className="d-flex justify-content-center">
                <h4>{beingRemovedName}?</h4>
              </Col>
            </Row>
            <Row>
              <Col className="d-flex justify-content-center">
                <AsyncButton
                  id={`${id}-ok`}
                  variant="danger"
                  aria-label={`Remove ${beingRemovedName}`}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onOk();
                  }}
                >
                  Remove
                </AsyncButton>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <AsyncButton
            id={`${id}-cancel`}
            aria-label="Cancel"
            variant="secondary"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onCancel();
            }}
          >
            Cancel
          </AsyncButton>
        </Modal.Footer>
      </Modal>
    </>
  );
};

RemoveModal.displayName = "RemoveModal";
